var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    transform: "translate(-156 -273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "local_phone-24px",
    transform: "translate(156 273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M0,0H15V15H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M5.262,7.869a9.468,9.468,0,0,0,4.119,4.119l1.375-1.375a.621.621,0,0,1,.637-.15,7.129,7.129,0,0,0,2.231.356.627.627,0,0,1,.625.625v2.181a.627.627,0,0,1-.625.625A10.624,10.624,0,0,1,3,3.625.627.627,0,0,1,3.625,3H5.812a.627.627,0,0,1,.625.625,7.1,7.1,0,0,0,.356,2.231.627.627,0,0,1-.156.638Z",
    transform: "translate(-1.125 -1.125)",
    fill: "#848484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.1b5d6e11e54d755d789f24f5f4835c5e.svg";
export { ForwardRef as ReactComponent };